<script>
  import { PowerButton } from '../_shared'

  export default {
    name: 'dashboard-notification',

    components: {
      PowerButton
    }
  }
</script>

<template>
  <section>
    <h5>Message from Hive</h5>

    <div class="notification card">
      <b-container fluid>
        <b-row>
          <b-col sm="8">
            <power-button :is-on="true"></power-button>
            <div class="content">
              <h5 class="heading">You are currently on a free trial of Hive</h5>
              <p>
                Upgrade your account to get full access to all the Hive has to offer. Your free trial ends on <span
                class="text-primary">October 31, 2019</span>.
              </p>
            </div>
          </b-col>
          <b-col sm="4" class="actions">
            <b-button variant="primary">Upgrade Now</b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </section>
</template>

<style src="./DashboardNotification.scss" lang="scss" scoped></style>
